import apiClient from "./api";

// afficher les transactions par domain
export const getTransactionByDomainId = async (domainId) => {
  const response = await apiClient.get(`/api/Transactions/all/${domainId}`);
  return response.data;
};



export const getTransactionByAccountId = async (
  accountId,
  domainId,
  page = 1,
  pageSize = 10
) => {
  const response = await apiClient.get(
    `/api/Transactions/by-account/${accountId}/${domainId}`,
    { params: { page, pageSize } }
  );
  return response.data;
};


/**
 * Récupère le volume total des transactions pour un domainId
 * GET /Transactions/volume_transaction/{domainId}
 */
export const getVolumeTransaction = async (domainId, year = null) => {
  try {
    const params = year ? { year } : {};
    const response = await apiClient.get(
      `/api/Transactions/volume_transaction/${domainId}`,
      { params }
    );
    // console.log("Volume total des transactions:", response.data);
    return response.data; 
  } catch (error) {
    // console.error('Erreur getVolumeTransaction:', error);
    return { count: 0, volume: 0 };
  }
};


/**
 * Récupère le volume des transactions privées pour un domainId
 * GET /Transactions/Private_volume/{domainId}
 */
export const getVolumeTransactionPrivate = async (domainId) => {
  try {
    const response = await apiClient.get(
      `/api/Transactions/Private_volume/${domainId}`
    );
    return response.data;
  } catch {
    throw new Error('Impossible de récupérer les données de transaction');
  }
};

/**
 * Récupère le volume des transactions publiques pour un domainId
 * GET /Transactions/Public_volume/{domainId}
 */
export const getVolumeTransactionPublic = async (domainId) => {
  try {
    const response = await apiClient.get(
      `/api/Transactions/Public_volume/${domainId}`
    );
    return response.data;
  } catch {
    throw new Error('Impossible de récupérer les données de transaction');
  }
};

export const getTotalCashPrivate = async (domainId, year = null) => {
  try {
    const params = year ? { year } : {};
    const response = await apiClient.get(
      `/api/Security/total-cash-all-security/private/${domainId}`,
      { params }
    );
    return response.data;
  } catch {
    // throw new Error('Impossible de récupérer les données de titres');
  }
};

export const getTotalCashPublic = async (domainId, year = null) => {
  try {
    const params = year ? { year } : {};
    const response = await apiClient.get(
      `/api/Security/total-cash-all-security/public/${domainId}`,
      { params }
    );
    return response.data;
  } catch {
    // throw new Error('Impossible de récupérer les données de titres');
  }
};

export const createTransaction = async (transactionData) => {
  try {
    const formData = new FormData();

    formData.append("OrderId", transactionData.orderId);
    formData.append("CreatorId", transactionData.creatorId);
    formData.append("Price", transactionData.price);
    formData.append("Quantity", transactionData.quantity);

    if (transactionData.preuve instanceof File) {
      formData.append("Preuve", transactionData.preuve);
    }

    const response = await apiClient.post(`/api/Transactions`, formData, {
      headers: { "Content-Type": "multipart/form-data" },
    });

    return response.data;

  } catch (error) {
    //  Mapper correctement
    const backendError =
      error.response?.data?.message ||  
      error.response?.data?.error ||  
      "Erreur inattendue du serveur";

    // console.error("Error creating Transaction:", backendError);

    //  On renvoie une exception propre
    throw new Error(backendError);
  }
};


/**
 * Récupère la répartition des transactions par type de compte pour un domainId
 * GET /api/TransactionByAccountType/{domainId}
 */
export const getTransactionByAccountType = async (domainId, year = null) => {
    const params = year ? { year } : {};
    const response = await apiClient.get(`/api/Transactions/TransactionByAccountType/${domainId}`, { params });
    return response.data;
};


// Récupérer le volume et le nombre de transactions pour un compte particulier 
export const getTransactionVolumeByAccount = async (accountId, domainId) => {
  const response = await apiClient.get(
    `/api/Transactions/TransactionVolumeByAccount/${accountId}/${domainId}`
  );
  // La réponse attendue contient { volume, count }
  return response.data;
};


// gerer la courbe d'evolution des transactions dans un domain precis
export const getMonthlyTransactionEvolution = async (domainId, year = null) => {
    const params = year ? { year } : {};
    const response = await apiClient.get(`/api/Transactions/monthly_evolution_transaction/${domainId}`, { params });
    return response.data;
};

// gerer la courbe d'evolution des transactions d'un client dans un domain precis
export const getEvolutionTransactionClient = async (accountId, domainId, year = null) => {
    const params = year ? { year } : {};
    const response = await apiClient.get(`/api/Transactions/GetEvolutionTransactionClient/${accountId}/${domainId}`, { params });
    return response.data;
};

// gerer la courbe d'evolution des transactions d'un client dans un domain precis
export const getAucTransactionClient = async (accountId, domainId) => {
  try {
      const response = await apiClient.get(`/api/Transactions/Getcash/${accountId}/${domainId}`);
      return response.data;
  } catch (error) {
      // console.error('Erreur lors de la récupération des données de transaction:', error);
      throw new error;
  }
};

// get by id d'une trsansaction
export const getTransactionById = async (transactionId) => {
  const response = await apiClient.get(`/api/Transactions/by-id/${transactionId}`);
  return response.data;
};


export const deleteTransaction = async (id) => {
  try {
    const response=await apiClient.delete(`/api/Transactions/${id}`);
    return response.data;
  }catch (error) {
    // console.error("Error deleting Transaction:", error.response?.data || error.message);
    throw new error;
  }
};



